import {
  Button,
  Grid,
  Box,
  IconButton,
  Stack,
  Typography,
  TextField as MuiTextField,
  Checkbox,
  Radio
} from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, dropdownFetch, getMonthYear } from '../../../../../utils';
import { dateFormatter, toast } from '../../../../../utils';
import axios from 'axios';

const TABLE_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.product?.main?.name
  }
];

const STORE_TABLE_HEADER = [
  {
    header: 'Product Name',
    accessor: (row) => row?.product?.name
  }
];

export const WarehouseStockTransferRequestDetailForm = ({ onClose, onAdd, productType ,rowId}) => {
  const [input, setInput] = useState('');
  const [inputs, setInputs] = useState('');
  const [productRemaining, setProductRemaining] = useState([]);
  const [storeProductDropdown, setStoreProductDropdown] = useState([]);
  const [productDropdown, setProductDropdown] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState(productType === 'pharmacy product' ? 'pharmacy' : 'general');

  function getMonthYear(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add leading zero if necessary
    return `${year}-${month}`;
  }

  const handleRadioChange = (event) => {
    const { name } = event.target;
    setSelectedRadio(name);
  };

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        product: Yup.string().required('Please Enter Product')
      })
    ),
    defaultValues: {
      po_qty: 0,
      free_qty: 0,
      loose_qty: 0,
      rec_qty: 0,
      quantity: 1,
      amount: 0,
      net_amt: 0,
      gst_amt: 0,
      disc_amt: 0,
      disc_per: 0,
      gst_per: 0,
      sgst: 0,
      cgst: 0
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
    formValues.gst_per = +formValues.gst_per;
    formValues.disc_per = +formValues.disc_per;
    formValues.quantity = +formValues.quantity;
    const { product, ...formValuesWithoutProduct } = formValues;
    let productId = '';
    let key = 'product';
    const foundProduct = productDropdown.find(({ product }) => product?.main?.name === formValues.product);
    if (foundProduct) {
      productId = foundProduct.product?._id;
      key = 'product';
    } else {
      const foundStoreProduct = storeProductDropdown.find(({ product }) => product?.name === formValues.product);
      if (foundStoreProduct) {
        productId = foundStoreProduct.product?._id;
        key = 'store_product';
      }
    }
    const transformedValues = {
      ...formValuesWithoutProduct, 
      [key]: productId ,
      issued_product : productId,
      _id : rowId
    };
console.log(transformedValues,"TRANFORMED VALUES ")
    onAdd(transformedValues);
    reset();
  };

  const handlePharamcyProductSelection = (row) => {
    console.log(row, 'HELLLLLLLO ROW');
    fetchStocks(row?.product?._id);
    setValue('product', row?.product?.main?.name);
    setValue('mrp', row?.mrp);
    setValue('sale_price', row?.mrp);
    setValue('conversion', row?.conversion);
    setValue('batch_no', row?.batch_no);
    setValue('exp_date', getMonthYear(row?.exp_date));
    setValue('cost_price', (row?.rate * row?.gst) / 100 + row?.rate);
  };

  const handleGeneralProductSelection = (row) => {
    console.log('ROW GENERAL', row);
    fetchStoreStocks(row?.product?._id);
    setValue('product', row?.product?.name);
    setValue('mrp', row?.mrp);
    setValue('sale_price', row?.mrp);
    setValue('conversion', row?.conversion);
    setValue('batch_no', row?.batch_no);
    setValue('exp_date', getMonthYear(row?.exp_date));
    setValue('cost_price', (row?.rate * row?.gst) / 100 + row?.rate);
  };

  const billQty = watch('bill_qty');
  const rate = watch('rate');
  const freeQty = watch('free_qty');
  const discPerWatch = watch('dis_percent');
  const discAmtWatch = watch('dis_amt');
  const gstPerWatch = watch('gst');
  const mrp = watch('mrp');

  useEffect(() => {
    const amount = billQty * rate;
    const RecQty = Number(freeQty) + Number(billQty);
    const discAmt = parseFloat(((amount * discPerWatch) / 100).toFixed(2));
    const taxable = parseFloat((amount - discAmt).toFixed(2));
    const gstAmt = parseFloat((((amount - discAmt) * gstPerWatch) / 100).toFixed(2));
    const netAmt = parseFloat((Number(taxable) + Number(gstAmt)).toFixed(2));
    const sgst = gstAmt / 2;
    setValue('amount', parseFloat(amount.toFixed(2)));
    setValue('dis_amt', discAmt || 0);
    setValue('gst_amt', gstAmt || 0);
    setValue('taxable', taxable || 0);
    setValue('rec_qty', RecQty || 0);
    setValue('sal_rate', mrp || 0);
    setValue('net_amt', netAmt || 0);
    setValue('sgst', sgst || 0);
    setValue('cgst', sgst || 0);
  }, [billQty, rate, discPerWatch, gstPerWatch, freeQty, setValue]);

  useEffect(() => {
    if (billQty && rate && discAmtWatch !== undefined) {
      const amount = billQty * rate;
      const newDiscPer = parseFloat(((discAmtWatch / amount) * 100).toFixed(2));
      setValue('dis_percent', newDiscPer);
    }
  }, [billQty, rate, discAmtWatch, setValue]);

  useEffect(() => {
    if (mrp !== undefined) {
      setValue('sal_rate', mrp);
    }
  }, [mrp, setValue]);

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const fetchStocks = async (rowId) => {
    const response = await axios.get(`${BASE_URL}/stock-master/total?name=${rowId}`);
    if (response?.data?.success) {
      const totalQuantity = response.data.data;
      const totalQuantitySum = totalQuantity.reduce((sum, item) => sum + item.totalQuantity, 0);
      setProductRemaining(totalQuantitySum);
      setValue('closing_qty', totalQuantitySum);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setProductRemaining({ loading: false, data: [] });
    }
  };

  const fetchStoreStocks = async (rowId) => {
    const response = await axios.get(`${BASE_URL}/store-stock-master/total?name=${rowId}`);
    if (response?.data?.success) {
      const totalQuantity = response.data.data;
      const totalQuantitySum = totalQuantity.reduce((sum, item) => sum + item.totalQuantity, 0);
      setProductRemaining(totalQuantitySum);
      setValue('closing_qty', totalQuantitySum);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setProductRemaining({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    handleProductSearch(input);
  }, [input]);

  const handleProductSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    setProductDropdown([]);
    try {
      const response = await axios.get(`${BASE_URL}/stock-master/dropdown?limit=${10}&name=${lowercasedInput}`);
      if (response.data.success) {
        const data = response?.data?.data;
        const filteredProducts = data.flatMap((item) =>
          item.productDetails.map((detail) => ({
            ...detail,
            _id: item._id,
            createdBy: item.createdBy,
            CreatedByDevice: item.CreatedByDevice,
            createdAt: item.createdAt
          }))
        );

        setProductDropdown(filteredProducts);
      } else {
        toast('Error in fetching data', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
    }
  };

  const handleInputsChange = (e) => {
    setInputs(e.target.value);
  };

  useEffect(() => {
    handleStoreProductSearch(inputs);
  }, [inputs]);

  const handleStoreProductSearch = async () => {
    const lowercasedInput = inputs.toLowerCase().trim();
    setStoreProductDropdown([]);
    try {
      const response = await axios.get(`${BASE_URL}/store-stock-master/dropdown?limit=10&name=${lowercasedInput}`);
      if (response.data.success) {
        const data = response?.data?.data;
        setStoreProductDropdown(data);
      } else {
        toast('Error in fetching data', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
    }
  };

  return (
    <Stack spacing={1}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="0px solid"
        borderColor="grey.300"
      >
        <Typography variant="h4" fontWeight="bold">
          Add Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>

      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={4}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ fontWeight: 700, fontSize: '1.2rem', flex: 2 }}>Product Type</Typography>
                <Radio
                  sx={{ flex: 0 }}
                  name="pharmacy"
                  checked={selectedRadio === 'pharmacy'}
                  onChange={handleRadioChange}
                />
                <Typography sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}>
                  Pharmacy Product
                </Typography>
                <Radio
                  sx={{ flex: 0 }}
                  name="general"
                  checked={selectedRadio === 'general'}
                  onChange={handleRadioChange}
                />
                <Typography sx={{ flex: 0, fontWeight: 700, fontSize: '1rem', color: 'red', fontSize: '1.2rem' }}>
                  General Product
                </Typography>
              </Stack>
            </Grid>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
              <MuiTextField
                sx={{
                  width: '100%',
                  '& .MuiOutlinedInput-root': {
                    padding: '0'
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '8px 14px'
                  }
                }}
                label="Search Product"
                variant="outlined"
                value={productType === 'pharmacy product' ? input : inputs}
                onChange={productType === 'pharmacy product' ? handleInputChange : handleInputsChange}
                InputProps={{
                  style: {
                    fontSize: '12px',
                    fontWeight: 600
                  }
                }}
              />
            </Stack>
            {productType === 'pharmacy product' ? (
              <Table
                containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
                size="small"
                sx={{ fontSize: '32px' }}
                data={productDropdown || []}
                columns={TABLE_HEADER}
                onRowClick={handlePharamcyProductSelection}
              />
            ) : (
              <Table
                containerSX={{ flex: 1, height: '100%', overflow: 'auto' }}
                size="small"
                sx={{ fontSize: '32px' }}
                data={storeProductDropdown.map((data) => ({ ...data })) || []}
                columns={STORE_TABLE_HEADER}
                onRowClick={handleGeneralProductSelection}
              />
            )}
          </Grid>
          <Grid item xs={8}>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Product</Typography>
              <TextField sx={{ flex: 0.6 }} name="product" placeholder="Select Product" disabled />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Closing Qty</Typography>
              <TextField sx={{ flex: 0.6 }} disabled name="closing_qty" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Requested Qty</Typography>
              <TextField sx={{ flex: 0.6 }} name="requested_qty" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
              <TextField sx={{ flex: 0.6 }} disabled name="batch_no" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Exp Date</Typography>
              <TextField sx={{ flex: 0.6 }} disabled name="exp_date" type="month" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>MRP</Typography>
              <TextField sx={{ flex: 0.6 }} disabled name="mrp" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center" sx={{ display: 'none' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Cost Price</Typography>
              <TextField sx={{ flex: 0.6 }} disabled name="cost_price" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center" sx={{ display: 'none' }}>
              <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Sale Price</Typography>
              <TextField sx={{ flex: 0.6 }} disabled name="sale_price" />
            </Stack>
            <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end">
              <Button variant="contained" type="submit">
                Add
              </Button>
              <Button variant="outlined" onClick={onClose} color="error">
                Close
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
